import cookie from './cookie';
import { getApiConfig } from '@/mx-service/libs/http/config'
import device from "./device";

export function is4aLogin(e, toLogin){
  // console.log('cookie MAS_TGC_UAT', cookie.getCookie('MAS_TGC_UAT'))
  // console.log('cookie MAS_TGC', cookie.getCookie('MAS_TGC'))
  // console.log('device.isMission()', device.isMission())
  if(device.isMission()) return true
  if(
      (!cookie.getCookie('MAS_TGC_UAT') && !cookie.getCookie('MAS_TGC'))
      ||
      window.location.pathname.indexOf("pcv5.html") > -1
      ||
      window.location.pathname.indexOf("wapv5.html") > -1
    ){
    console.log('未登录')
    toLogin && to4aLogin(e)
    return false
  }
  return true
}

function to4aLogin(id){
  const hostList = getApiConfig()
  console.log('hostList', hostList)
  const url = window.encodeURIComponent(hostList._4aPCUrl + `#/?id=${id}`)
  console.log('url', url)
  window.location.href = hostList._4aUrl + url
}

